module.exports = __webpack_public_path__ + "static/media/PATS_6-1920w.8ac63a3f.png";